import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import ErrorsReducer from "./ErrorsReducer";
import clientReducer from "./ClientReducer";
import pointsReducer from "./PointsReducer";
import featuredItemReducer from "./featuredItemReducer";

const rootReducer = combineReducers({
    AuthReducer,
    ErrorsReducer,
    clientReducer,
    pointsReducer,
    featuredItemReducer,
});

export default rootReducer;
